export class AttributeValueParserProcessor {
    constructor(cherryPicks) {
        this.cherryPicks = cherryPicks;
    }
    invoke(productItem, attrComputer) {
        console.groupCollapsed('Product Item Attributes');
        console.log('Before', productItem.getAttributes());
        productItem.setAttributes(this.parseAttributes(productItem.getAttributes(), attrComputer));
        console.log('After', productItem.getAttributes());
        console.groupEnd();
        console.groupCollapsed('Cherry Pick Attributes');
        console.log('Before', this.cherryPicks.getAttributes());
        this.cherryPicks.setAttributes(this.parseAttributes(this.cherryPicks.getAttributes(), attrComputer));
        console.log('After', this.cherryPicks.getAttributes());
        console.groupEnd();
    }
    parseAttributes(attributes, attrComputer) {
        var _a;
        const finalAttrbutes = {};
        for (const [attrName, attrValue] of Object.entries(attributes)) {
            const startValue = attrValue;
            if ((Array.isArray(attrValue) && attrValue.length > 0) || ['number', 'string', 'boolean'].includes(typeof attrValue)) {
                finalAttrbutes[attrName] = (_a = attrComputer.parseAttribute(attrName, attrValue)) !== null && _a !== void 0 ? _a : attrValue;
                const finalValue = finalAttrbutes[attrName];
                if (startValue !== finalValue) {
                    console.log(`Changing "${attrName}"`, 'from', startValue, 'to', finalValue);
                }
            }
            else {
                console.log(`Removing "${attrName}"`, startValue);
            }
        }
        return finalAttrbutes;
    }
}
